import React from 'react'

const Careers = () => {
  return (
    <div>
      Carrer Info
    </div>
  )
}

export default Careers

